

import React, {useEffect, useState} from 'react';
import {config} from '../../../../base/constant'
import useDrivePicker from 'react-google-drive-picker'
import { TPIService } from '../../../../base/tpiService';
import { getCookie } from '../../../../base/utils';
import store from '../../../../context/store/store';
const GoogleDrive=()=> {
    const [openPicker, authResponse] = useDrivePicker();  
    let meetingReducer: any = store.getState().meetingReducer;
    const {planBased} =meetingReducer;
    const [googleDriveBtn, setGoogleDriveBtn] = useState(false);

    const handleOpenPicker=()=> {
        console.log("handle open picker------")
        let token:any = getCookie("ssoToken");
        openPicker({
            clientId:config().GOOGLE_CLIENTID,
            developerKey:config().GOOGLE_DEVELOPER_KEY,
            customScopes:config().GOOGLE_SCOPE,
            callbackFunction:(data:any)=>{
                console.log(" callback data",data);
                if( data.action ===  "picked"){
                    var fileId = data.docs[0];
                    TPIService.uploadAndDisplayFiles(fileId.name, fileId.mimeType,
                        "https://www.googleapis.com/drive/v3/files/" +fileId.id +"?alt=media" ,token , fileId.id, fileId.url);
                }
            }
        })
    }

    useEffect(() => {
   
        // {Chat attach file - Google Drive}
        const GoogleDriveFeature = planBased.find((item:any) => item.featureid === 792);
        if (GoogleDriveFeature && GoogleDriveFeature.value1 === "Yes") {
            setGoogleDriveBtn(false); 
        } else {
            setGoogleDriveBtn(true);
        }
        
      }, [planBased]); 
     

    return (
        <>
        <li className={`${googleDriveBtn ? 'disabledIcon':''}`} onClick={handleOpenPicker}>
          <span className="icon_drive"></span> Google Drive
        </li>
   
      </>
      );
}
export default GoogleDrive;